/**
 * Owner action to open the bound worktree on the execution host.
 * Renders a real button only when the host can do it.
 */
import type { IdeLaunchDecision } from '@brunel/shared';

export function IdeLaunchControl({
  decision,
  busy,
  error,
  ok,
  onOpen,
}: {
  readonly decision: IdeLaunchDecision;
  readonly busy: boolean;
  readonly error: string | null;
  readonly ok: string | null;
  readonly onOpen: () => void;
}) {
  if (decision.action === 'unavailable') {
    return (
      <p className="muted ide-launch-status" role="status" data-testid="ide-launch-unavailable">
        {decision.detail}
      </p>
    );
  }
  return (
    <div className="ide-launch stack tight">
      <button
        type="button"
        className="ghost"
        disabled={busy}
        onClick={onOpen}
        data-testid="ide-launch-open"
      >
        {busy ? 'Opening…' : `Open in ${decision.displayName}`}
      </button>
      <small className="muted">Available on {decision.nodeName}</small>
      {error && <p className="error" role="alert">{error}</p>}
      {ok && <p className="muted" role="status">{ok}</p>}
    </div>
  );
}
